/**
 * Spanish lead magnet ("Guía de Cirugía Bariátrica en el Norte de Virginia").
 * Kept in its own module so both the client component and the server function
 * can import the path without pulling in server code.
 *
 * The PDF itself is generated by scripts/generate-es-guide-pdf.py.
 */
export const SPANISH_GUIDE_PATH =
  "/guias/guia-cirugia-bariatrica-norte-de-virginia.pdf";

export const SPANISH_GUIDE_TITLE =
  "Guía de Cirugía Bariátrica en el Norte de Virginia";

export const SPANISH_GUIDE_FILENAME =
  "guia-cirugia-bariatrica-norte-de-virginia.pdf";
